module.exports = __webpack_public_path__ + "static/media/steering-wheel.f5aed07d.svg";